<template>
  <div>
    <div
      class="background-image-login"
         :style="[settings.loginBackgroundImage && settings.loginBackgroundImage.absoluteUri ? {'backgroundImage': 'url(' + settings.loginBackgroundImage.absoluteUri + ')'} : {'backgroundImage': 'url(img/temp/cook.jpg)'}]"
    ></div>
    <!-- Header -->
    <div class="header py-8 py-lg-8 pt-lg-9">
      <b-container>
        <div class="header-body text-center mb-3">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-1">
              <h1 class="text-white">{{ client && client.name ? client.name : 'WhipStir'}} Recipe Database</h1>
              <p class="text-lead text-white">
                Search for your favorite recipes from our chefs. Log in here to get started!
              </p>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="6" md="8">
          <b-card no-body class="bg-secondary border-0 mb-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <div class="login-error" v-if="errorMessage != null && Object.keys(errorMessage).length != 0">
                <p>{{ errorMessage }}</p>
              </div>

              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <b-form
                  role="form"
                  @submit.prevent="handleSubmit(onSubmit)"
                  class="login-form"
                >
                  <base-input v-if="step !== '2fa'"
                    label="Email Address"
                    alternative
                    class="mb-3"
                    name="Email"
                    :rules="{ required: true, email: true }"
                    prepend-icon="ni ni-email-83"
                    placeholder="example@email.com"
                    v-model="email"
                  >
                  </base-input>

                  <base-input v-if="step !== '2fa'"
                    label="Password"
                    alternative
                    class="mb-3"
                    name="Password"
                    :rules="{ required: true, min: 6 }"
                    prepend-icon="ni ni-lock-circle-open"
                    type="password"
                    v-model="password"
                  >
                  </base-input>

                  <div v-if="step === '2fa'">
                    <base-input
                    label="2FA Code"
                    alternative
                    class="mb-3"
                    name="2FACode"
                    :rules="{ required: true, min: 6 }"
                    prepend-icon="ni ni-lock-circle-open"
                    type="text"
                    v-model="totpCode"
                    >
                    </base-input>
                  </div>

                  <!-- <b-form-checkbox v-model="model.rememberMe">Remember Me</b-form-checkbox> -->
                  <div class="text-center" v-if="step !== '2fa'">
                    <base-button
                      type="primary"
                      native-type="submit"
                      class="my-4"
                      >{{
                        loggingIn ? "Signing In..." : "Sign In"
                      }}</base-button
                    >
                  </div>

                  <div class="text-center" v-if="step === '2fa'">
                  <base-button @click="verify2FA"
                    type="primary"
                    class="my-4"
                    >{{
                      loggingIn ? "Validating..." : "Validate"
                    }}</base-button
                  >
                  </div>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
          <b-row class="mt-3">
            <b-col cols="6">
              <router-link to="/forgot-password" class="text-light"
                ><small>Forgot Your Password?</small></router-link
              >
            </b-col>
            <b-col cols="6" class="text-right">
              <router-link to="/register" class="text-light"
                ><small>Create A New Account</small></router-link
              >
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
  import axios from 'axios';

export default {
  data() {
    return {
      email: "",
      password: "",
      step: "login",
      tempUserId: "",
      totpCode: "",
      submitted: false,
      submitting: false,
    };
  },
  computed: {
    client() {
      return this.$store.state.clients.current;
    },
    settings() {
      return this.$store.state.settings.current;
    },
    loggingIn() {
      return this.$store.state.authentication.status.loggingIn;
    },
    errorMessage() {
      return this.$store.state.alert.message;
    }
  },
  created() {
    this.$store.state.alert.message = '';

    var urlParams = new URLSearchParams(window.location.search);
    var client = urlParams.get('host');
    
    let $this = this.$store;
    $this.dispatch("clients/getCurrentClient", client)
    setTimeout(function() {
      $this.dispatch("settings/getSettings", $this.state.clients.current.id);
    }, 2500);
  },
  methods: {
    onSubmit(e) {
      const { email, password } = this;
      const { dispatch } = this.$store;
      
      if (!email || !password) return;

      var clientId = this.$store.state.clients.current.id;
  
      const user = {
        "email": email,
        "password": password,
        "clientId": clientId
      }

      // Call login API directly instead of using Vuex dispatch yet
      axios.post(`${process.env.VUE_APP_API_HOSTNAME}/api/users/authenticate`, JSON.stringify(user), { headers: { 'Content-Type': 'application/json'} })
        .then((res) => {
          if (res.data.isTwoFactorEnabled) {
            // Move to the 2FA step in the login UI
            this.step = "2fa";
            this.tempUserId = res.data.user.id;
          } else if (res.data.token) {
            // Normal login: pass token to Vuex store
            res.data.user.email = this.email;
            res.data.user.token = res.data.token;
            dispatch("authentication/setToken", res.data);
          }
        })
        .catch((err) => {
          //this.loginError = err.response?.data?.message || "Login failed.";
        });
    },
    verify2FA() {
      const { tempUserId, totpCode } = this;
      const { dispatch } = this.$store;
      if (!tempUserId || !totpCode) return;

      axios.post(`${process.env.VUE_APP_API_HOSTNAME}/api/users/verify-2fa`, { userId: tempUserId, code: totpCode })
        .then((res) => {
          if (res.data.token) {
            res.data.user.email = this.email;
            res.data.user.token = res.data.token;
            dispatch("authentication/setToken", res.data);
          } else {
            this.loginError = "Invalid code.";
          }
        })
        .catch((err) => {
          //this.loginError = err.response?.data?.message || "2FA verification failed.";
        });
    },
  },
};
</script>
